export default __webpack_public_path__ + "static/media/sidebar.55a1989f.jpg";